import { formatDate } from '@/utils/date';

export const getShipmentDefaultFilters = () => ({
  CreatedDateFrom: undefined,
  CreatedDateTo: undefined,
  pageNumber: 1,
  pageSize: 10,
  ShipmentNo: undefined,
  ShipmentStatus: undefined,
  trailerNumber: undefined,
});

export const SaversShipmentColumns = {
  data: [
    {
      columnName: 'Trailer Number',
      columnValue: 'trailerNumber',
    },
    {
      columnName: 'Empty/Loaded',
      columnValue: 'trailerStatus',
    },
    {
      columnName: 'Carrier Name',
      columnValue: 'carrierName',
    },
    {
      columnName: 'Origin Location',
      columnValue: 'originLocation',
    },
    {
      columnName: 'Destination Location',
      columnValue: 'destinationLocation',
    },
    {
      columnName: 'ETD',
      columnValue: 'etd',
      render: (text) => formatDate(text),
    },
    {
      columnName: 'ETA',
      columnValue: 'eta',
      render: (text) => formatDate(text),
    },
    {
      columnName: 'Assigned To',
      columnValue: 'trafficCoordinatorName',
    },
    {
      columnName: 'Shipping Complete',
      columnValue: 'shippingComplete',
    },
    {
      columnName: 'Receiving Complete',
      columnValue: 'receivingComplete',
    },
  ],
  error: false,
  message: false,
  progressing: false,
  success: true,
};

export const USER_TYPES = {
  ct: 'CT',
  store: 'STORE',
  supplier: 'SUPPLIER',
};

export const SHIPMENT_TYPE = {
  dest: 'destination',
  org: 'origin',
};

export const SHIPMENT_FILTER_DATES_FIELDS = [
  'ExpShipFrom',
  'ExpShipTo',
  'CreatedDateFrom',
  'CreatedDateTo',
  'assignedTo',
  'eta',
  'etd',
  'originLocation',
  'destinationLocation',
];

export const WEIGHT_PER_UNIT = 23;

export const INITIAL_TRAILER_DETAILS = {
  Commodity: null,
  emptyDate: null,
  entryDate: null,
  PartnerLocation: null,
  PickupRentalCompany: null,
  productType: null,
  selPartner: null,
  selTrailer: null,
  selYardValue: null,
  trailerReceivings: [
    {
      destinationBookOks: 0,
      destinationBookWeight: 0,
      destinationConsignee: null,
      destinationETA: null,
      destinationFurn: 0,
      destinationLocationId: null,
      destinationMiscOks: 0,
      destinationMiscWeight: 0,
      destinationOLI: 0,
      destinationSoftOks: 0,
      destinationSoftWeight: 0,
    },
  ],

  trailerShippings: [
    {
      originBookOks: 0,
      originBookWeight: 0,
      originETD: null,
      originFurn: 0,
      originLocationId: null,
      originMiscOks: 0,
      originMiscWeight: 0,
      originOLI: 0,
      originShipLocation: null,
      originSoftOks: 0,
      originSoftWeight: 0,
      originSpotDate: null,
    },
  ],
  txtinvJusti: null,
  txtRSCM: null,
  txtSCS: null,
  txtUserName: null,
  UnitSize: null,
  unitEmpty: false,
};

export const ALLOWED_PRODUCT_VALUES = [1, 2, 3];

export const PICKUP_TIME_OPTIONS = [
  {
    label: '8 AM',
    value: '8 AM',
  },
  {
    label: '12 PM',
    value: '12 PM',
  },
  {
    label: '4 PM',
    value: '4 PM',
  },
];
